"use strict";
exports.__esModule = true;
exports.GLOBAL_CONSTANTS = exports.BOT_GLOSSARY = exports.BUSINESS_V2 = void 0;
var const_1 = require("@src/const");
/*
 * constructs a full url
 * @param url endpoint for the url
 */
var URL = function (url) { return "" + const_1.BASE_URL + url; };
var GENERAL_SETTINGS_URL = 'businesses/:businessId/general_settings/';
var TASKBOX_URL = 'businesses/:businessId/tasks/';
var BOT_BREAK_URL = 'businesses/:businessId/bot_break_templates/';
var FEEDBACK_MESSAGES_URL = 'v1/businesses/:businessId/feedback_messages/';
var SDK_CONFIG_URL = 'businesses/:businessId/sdk_config/';
var BOT_GLOSSARY_URL = 'glossary/:domainId/';
var GLOBAL_CONSTANTS_URL = 'bot/:domainId/globalconstants';
exports.BUSINESS_V2 = {
    GET: {
        BUSINESS_DATA: URL(GENERAL_SETTINGS_URL),
        SDK_CONFIG: URL(SDK_CONFIG_URL),
        TASKS: URL(TASKBOX_URL),
        BOT_BREAK_TEMPLATES: URL(BOT_BREAK_URL),
        FEEDBACK_MESSAGES: URL(FEEDBACK_MESSAGES_URL),
        BUSINESS_MANAGER_VERSION: URL("businesses/:businessIdentifier/version/"),
        PARTNER_LIST: const_1.BASE_URL.replace('/mogambo_api', '') + "admin_tools/permission/expert/partner/",
        GEN_AI_SALES_DATA: URL('businesses/'),
    },
    PUT: {
        BUSINESS_DATA: URL(GENERAL_SETTINGS_URL),
        TASKS: URL(TASKBOX_URL),
        BOT_BREAK_TEMPLATES: URL(BOT_BREAK_URL),
        FEEDBACK_MESSAGES: URL(FEEDBACK_MESSAGES_URL),
        SDK_CONFIG: URL(SDK_CONFIG_URL),
    },
    POST: {
        BUSINESS: URL('businesses/general_settings/'),
    },
};
exports.BOT_GLOSSARY = {
    GET: {
        GLOSSARY: URL(BOT_GLOSSARY_URL),
    },
    POST: {
        GLOSSARY: URL(BOT_GLOSSARY_URL),
    },
};
exports.GLOBAL_CONSTANTS = {
    POST_PUT: URL(GLOBAL_CONSTANTS_URL),
};
